import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer 
      className="py-5 mt-auto"
      style={{ 
        backgroundColor: 'var(--text-primary)',
        color: 'rgba(255, 255, 255, 0.8)'
      }}
    >
      <div className="container px-5">
        <div className="row g-4 align-items-center">
          {/* Logo & Description */}
          <div className="col-lg-4 text-center text-lg-start">
            <img
              src="logo-pichos-155x55.png"
              alt="Clínica Veterinaria Pichos"
              style={{ maxHeight: '45px', filter: 'brightness(0) invert(1)', opacity: 0.9 }}
              className="mb-3"
            />
            <p className="small mb-0" style={{ opacity: 0.7 }}>
              Cuidando a tus mascotas desde 1992
            </p>
          </div>
          
          {/* Contact Info */}
          <div className="col-lg-4">
            <div className="d-flex flex-column gap-2 text-center text-lg-start">
              <a 
                href="tel:+56322497632" 
                className="text-decoration-none d-flex align-items-center justify-content-center justify-content-lg-start gap-2"
                style={{ color: 'rgba(255, 255, 255, 0.8)' }}
              >
                <FontAwesomeIcon icon={faPhone} style={{ color: 'var(--primary-light)' }} />
                <span>+56 32 249 7632</span>
              </a>
              <div className="d-flex align-items-center justify-content-center justify-content-lg-start gap-2">
                <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: 'var(--primary-light)' }} />
                <span>Buenos Aires 796, Valparaíso</span>
              </div>
            </div>
          </div>
          
          {/* Team & Social */}
          <div className="col-lg-4 text-center text-lg-end">
            <div className="d-flex flex-wrap justify-content-center justify-content-lg-end gap-2 mb-3">
              <span className="badge" style={{ background: 'rgba(255,255,255,0.1)', padding: '8px 12px' }}>
                Dr. Claudio Tramon
              </span>
              <span className="badge" style={{ background: 'rgba(255,255,255,0.1)', padding: '8px 12px' }}>
                Dr. Ignacio Tramon
              </span>
              <span className="badge" style={{ background: 'rgba(255,255,255,0.1)', padding: '8px 12px' }}>
                Dra. Nicole Robles
              </span>
            </div>
            
            {/* Social Icons */}
            <div className="d-flex gap-3 justify-content-center justify-content-lg-end">
              <a 
                href="https://www.facebook.com/293435430831934"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
                style={{ 
                  color: 'white', 
                  opacity: 0.7,
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.opacity = 1}
                onMouseLeave={(e) => e.target.style.opacity = 0.7}
              >
                <FontAwesomeIcon icon={faFacebook} size="lg" />
              </a>
              <a 
                href="https://www.instagram.com/clinicaveterinariapichos"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
                style={{ 
                  color: 'white', 
                  opacity: 0.7,
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.opacity = 1}
                onMouseLeave={(e) => e.target.style.opacity = 0.7}
              >
                <FontAwesomeIcon icon={faInstagram} size="lg" />
              </a>
            </div>
          </div>
        </div>
        
        {/* Divider */}
        <hr className="my-4" style={{ borderColor: 'rgba(255,255,255,0.1)' }} />
        
        {/* Copyright */}
        <div className="text-center">
          <small style={{ opacity: 0.5 }}>
            © {currentYear} Clínica Veterinaria Pichos. Todos los derechos reservados.
          </small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
